import { GeminiUsageLevelEnum } from '@workalizer/shared/enums';
import { GEMINI_USAGE_LEVELS, getGeminiAdoptionTrendWeekPeriods } from '@workalizer/shared/lib/gemini-usage-level';
import { getPreviousPeriod } from '@workalizer/shared/utils';
import { format } from 'date-fns';
var LEVEL_CYCLE = [
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.LOW,
    GeminiUsageLevelEnum.HIGH,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.HIGH,
    GeminiUsageLevelEnum.LOW
];
var PREVIOUS_LEVEL_CYCLE = [
    GeminiUsageLevelEnum.LOW,
    GeminiUsageLevelEnum.ZERO,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.LOW,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.ZERO
];
var TEAM_LEVEL_CYCLE = [
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.HIGH,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.HIGH,
    GeminiUsageLevelEnum.LOW
];
export var geminiAdoptionTrend = function (input) {
    var dateFrom = format(new Date(input.dateFrom), 'yyyy-MM-dd');
    var dateTo = format(new Date(input.dateTo), 'yyyy-MM-dd');
    var weekPeriods = getGeminiAdoptionTrendWeekPeriods(dateFrom, dateTo);
    var _a = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var previousWeekPeriods = getGeminiAdoptionTrendWeekPeriods(prevPeriodDateFrom, prevPeriodDateTo);
    var usersInScope = input.userId ? 1 : 204;
    return {
        usersInScope: usersInScope,
        weeks: weekPeriods.map(function (week, index) {
            var _a, _b;
            var userLevel = LEVEL_CYCLE[index % LEVEL_CYCLE.length];
            var previousUserLevel = PREVIOUS_LEVEL_CYCLE[index % PREVIOUS_LEVEL_CYCLE.length];
            var teamUserLevel = TEAM_LEVEL_CYCLE[index % TEAM_LEVEL_CYCLE.length];
            var previousWeek = previousWeekPeriods[index];
            var levels = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
                acc[level] =
                    level === userLevel && input.userId
                        ? 1
                        : Math.max(10, 40 - index * 5 - GEMINI_USAGE_LEVELS.indexOf(level) * 3);
                return acc;
            }, {});
            var previousLevels = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
                acc[level] =
                    level === previousUserLevel && input.userId
                        ? 1
                        : Math.max(8, 30 - index * 4 - GEMINI_USAGE_LEVELS.indexOf(level) * 2);
                return acc;
            }, {});
            return {
                period: week.period,
                dateFrom: week.dateFrom,
                dateTo: week.dateTo,
                previousDateFrom: (_a = previousWeek === null || previousWeek === void 0 ? void 0 : previousWeek.dateFrom) !== null && _a !== void 0 ? _a : null,
                previousDateTo: (_b = previousWeek === null || previousWeek === void 0 ? void 0 : previousWeek.dateTo) !== null && _b !== void 0 ? _b : null,
                levels: levels,
                previousLevels: previousLevels,
                userLevel: input.userId ? userLevel : null,
                previousUserLevel: input.userId ? previousUserLevel : null,
                teamUserLevel: input.userId ? teamUserLevel : null
            };
        })
    };
};
